<template>
  <div 
    :class="{ 'invalid': !isValid, 'valid': isValid}" 
    v-click-outside="closeComplete"
  >
    <label v-if="!hasNoLabel" :for="name">{{label}}</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <input 
      autocomplete="off"
      :id="name" 
      :name="name" 
      :disabled="isDisabled" 
      :placeholder="placeholder" 
      :value="newVal"
      :class="{'autocomplete-active': this.isOpen}"
      @input="updateField($event)"
      @focus="openComplete"
      @keyup.enter="selectItem(0)"
    >
      <!-- @keyup.enter="amountNeeded <= result[0].amountLeft ? selectItem(0) : warnAmount(result[0].amountLeft)" -->
    <div 
      class="select-autocomplete"
      :class="{'select-lessTop': this.hasLessTop, 'select-moreTop': this.hasMoreTop}" 
      v-if="this.isOpen && searchResult[0] != 'emptyField'"
    >
      <div 
        v-if="searchResult.length < 1"
        class="select-row"
      >
        <span class="main-step">No batches found</span>
      </div>
      <div 
        v-else
        class="select-row"
        v-for="(result, index) in searchResult" 
        :key="index"
        @click="selectItem(index)"
      >
        <!-- @click="amountNeeded <= result.amountLeft ? selectItem(index) : warnAmount(result.amountLeft)" -->
        <span 
          class="main-step"
          :class="{'warning': amountNeeded > result.amountLeft}"
        >{{result.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed : {},
  props: {
    searchUrl: String,
    label: String,
    name: String,
    value: String,
    isTextArea: Boolean,
    isDisabled: Boolean,
    placeholder: String,
    restrictedPart: String,
    amountNeeded: Number,
    hasLessTop: {
      type: Boolean,
      default: false
    },
    hasMoreTop: {
      type: Boolean,
      default: false
    },
    hasNoLabel: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      newVal: '',
      searchTerm: '',
      searchResult: ['emptyField'],
      isOpen: false,
      selectedItem: null,
      isValid: Boolean,
      errorDescription: this.label + ' is not valid'
    }
  }, 
  mounted() {
    this.newVal = this.value
  },
  methods: {
    selectItem(index) {      
      this.selectedItem = this.searchResult[index]
      this.newVal = this.selectedItem.name
      this.$emit("selectedItem", this.selectedItem)
      this.closeComplete()
      this.searchTerm = ''
      this.searchResult = []
    },
    updateField(event) {
      this.newVal = event.target.value
      this.searchTerm = event.target.value
      this.getResults()
      this.$emit('input', event.target.value)
    },   
    warnAmount(amoutInBon) {
      this.$swal(
        'Not enough subparts?',
        `This batch only has ${ amoutInBon } items, while ${ this.amountNeeded } are needed. Please select another batch.`,
        'warning'
      );
      this.newVal = ''
    },   
    getResults() {
      var that = this
      if (this.searchTerm != "") {
        that.searchResult = []
        this.$http.get(this.$endpoint + this.searchUrl + "search/" + this.searchTerm + '/' + this.restrictedPart)
        .then(response => {
          console.log(response)
          for (var i = 0; i < response.data.length; i++) {
            that.searchResult.push({'id': response.data[i].bonID, 'name': response.data[i].bonID, 'amount': response.data[i].amount, 'amountLeft': response.data[i].amountLeft, 'bonPartID': response.data[i].bonPartID,'ref':response.data[i].ref})
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
      } else {
        this.searchResult = ['emptyField']
      }
    },
    openComplete() {
      this.isOpen = true
    },
    closeComplete() {
      this.isOpen = false
    },
  },
  watch: {
    validation: function(newVal, oldVal) {
      this.isValid = newVal
    },
    value: function(val) {
      this.newVal = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/autocompleteList";

.autocomplete-active {
  z-index: 101;
}

.icon.autocomplete-active {
  z-index: 102;
}

.select-autocomplete {
  width: 100%;
}

.warning {
  color: $error-color !important;
}
</style>
